interface Community {
  community_id: number
  code: string
  name: string
}

export const customer = {
  processor: (customer: any, data: any) => {
    customer.communities = data.community.map((community: Community) => ({
      communityId: community.community_id,
      name: community.name,
      code: community.code
    }))
    customer.customerType = data.customer_type
  }
}
